import { useCallback } from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";
import MonthPicker from "./MonthPicker";
import type { MonthPickerProps } from "./types";
import { Grid, Typography, styled } from "@mui/material";

import { MAIN_STYLES } from "@constants";

const TypographyTitle = styled(Typography)({
  color: "#111111",
  fontWeight: "700",
  fontSize: "16px",
  alignSelf: "center",
  padding: "0 10px",
});


interface Props {
  onChange?: (
    startMonth: string | undefined,
    endMonth: string | undefined
  ) => void;
  menuPlacement?: "left" | "right";
}

const FuncComponent: React.FC<Props> = ({ onChange, menuPlacement = "left" }) => {
  const { t } = useTranslation();

  const handleOnChange: MonthPickerProps["onChange"] = useCallback(
    (dateRange: [Date | null, Date | null]) => {
      if (!onChange) return;
      
      const [start, end] = dateRange;
      
      if (!start || !end) {
        onChange(undefined, undefined);
      } else {
        onChange(
          moment(start).format("YYYY-MM-DD"),
          moment(end).format("YYYY-MM-DD")
        );
      }
    },
    [onChange]
  );

  return (
    <Grid display={"flex"} flexDirection={"row"} alignItems={"center"}>
      <TypographyTitle sx={{ paddingBottom: 0 }}>
        {t("ota_detailed_analysis.period")}
      </TypographyTitle>
      <MonthPicker
        closeDelay={500}
        highlightCol={MAIN_STYLES.mainPurple}
        defaultTitle={t("write_review_page.entire_period")}
        onChange={handleOnChange}
        menuPlacement={menuPlacement}
      />
    </Grid>
  );
};

export default FuncComponent;
